import AIScraper from '#app/components/aiScraper/aiScraper.tsx'

export default function AIScraperPage() {
	return <AIScraper />
}
